module.exports = require("./kn.d.ts");